import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const CurrentItem = ({ children }) => <View>{children}</View>;

const View = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  padding: 0 13px;
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.white};
  border-radius: 4px;
  border: 1px solid ${Colors.solitude};
  color: ${Colors.coal};
`;
